import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {

    configState: {
        data: null,
        loading: null,
        error: null,
    },
    singleSaleInvoiceState: {
        data: null,
        loading: null,
        submitting: null,
        error: null,
    }
}


export const fetchConfigData = createAsyncThunk(
    'fetchConfigData',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            dispatch(fetchConfigDataStart());

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/config/invoiceType/65d99ed402075e96b75f9400`);

            dispatch(fetchConfigDataSuccess(response.data.data));

            return response.data;

        } catch (error) {
            const errorMessage = error.response?.data?.message || 'An unknown error occurred';
            dispatch(fetchConfigDataFailure(errorMessage));
            return rejectWithValue(errorMessage);
        }
    }
);


export const fetchSaleInvoiceSingle = createAsyncThunk(
    'saleOrder/fetchSaleInvoiceSingle',
    async (entityId, { dispatch, rejectWithValue, getState }) => {
        try {
            dispatch(fetchSaleInvoiceSingleStart());

            let response = await axios.get(`${process.env.REACT_APP_API_URL}/api/sale-order/invoice/${entityId}`);

            if (response?.status) {

                dispatch(fetchSaleInvoiceSingleSuccess(response.data?.data));

            } else {
                const errorMsg = response?.data?.message ?? 'Something went wrong!!';
                dispatch(fetchSaleInvoiceSingleFailure(errorMsg));
                return rejectWithValue(errorMsg);
            }


        } catch (error) {
            const errorMsg = error?.message ?? 'Something went wrong!!';
            dispatch(fetchSaleInvoiceSingleFailure(errorMsg));
            return rejectWithValue(errorMsg);
        }
    }
)


const invoiceSlice = createSlice({
    name: 'invoice',
    initialState,
    reducers: {

        fetchConfigDataStart(state) {
            state.configState.loading = true;
            state.configState.error = null;
        },
        fetchConfigDataSuccess(state, action) {
            state.configState.loading = false;
            state.configState.data = action.payload ?? [];
            state.configState.error = null;
        },
        fetchConfigDataFailure(state, action) {
            state.configState.loading = false;
            state.configState.error = action.payload;
        },

        fetchSaleInvoiceSingleStart(state) {
            state.singleSaleInvoiceState.loading = true;
            state.singleSaleInvoiceState.error = null;
        },
        fetchSaleInvoiceSingleSuccess(state, action) {
            state.singleSaleInvoiceState.loading = false;
            state.singleSaleInvoiceState.data = action.payload;
            state.singleSaleInvoiceState.error = null;
        },
        fetchSaleInvoiceSingleFailure(state, action) {
            state.singleSaleInvoiceState.loading = false;
            state.singleSaleInvoiceState.error = action.payload;
        },

    }
})

export const { fetchConfigDataStart, fetchConfigDataSuccess, fetchConfigDataFailure, fetchSaleInvoiceSingleStart, fetchSaleInvoiceSingleSuccess, fetchSaleInvoiceSingleFailure, } = invoiceSlice.actions;

export default invoiceSlice.reducer;